import {Controller} from '@hotwired/stimulus';
import {smoothScrollTo} from '../lib/smooth_scroll.js';

export default class extends Controller {
    connect() {
        this.update = this.update.bind(this);
        window.addEventListener('scroll', this.update, {passive: true});
        this.update();
    }

    disconnect() {
        window.removeEventListener('scroll', this.update);
    }

    update() {
        const visible = window.scrollY > Math.min(window.innerHeight * 0.8, 720);

        this.element.classList.toggle('is-visible', visible);
        this.element.setAttribute('aria-hidden', visible ? 'false' : 'true');
        this.element.tabIndex = visible ? 0 : -1;
    }

    scroll() {
        smoothScrollTo(0);

        if (window.location.hash) {
            window.history.replaceState(
                window.history.state,
                '',
                `${window.location.pathname}${window.location.search}`,
            );
        }
    }
}
